import React from 'react';
import { Link } from 'react-router-dom';
import RecipeCard from './RecipeCard';
import { recipes } from '../data/dataPasta';

const RecipePasta = () => {
  const featuredRecipes = recipes.filter(recipe => recipe.featured);
  
  return (
    <section className="featured-recipes section">
      <div className="container">
        <h2 className="section-title">Pasta Recipes</h2>
        
        <div className="recipes-grid">
          {featuredRecipes.map(recipe => (
            <RecipeCard key={recipe.id} recipe={recipe} />
          ))}
        </div>
        
        <div className="view-all">
          <Link to="/category/all" className="btn btn-outline">View All Recipes</Link>
        </div>
      </div>
      
      <style jsx>{`
        .recipes-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 2rem;
          margin-bottom: 3rem;
        }
        
        .view-all {
          text-align: center;
        }
        
        @media (max-width: 992px) {
          .recipes-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        
        @media (max-width: 576px) {
          .recipes-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </section>
  );
};

export default RecipePasta;